import React from 'react';
import { COMPANY_OVERVIEW } from '../content';
import styles from './CompanyOverviewFooter.module.css';

const LOGO_WHITE_SRC = `${process.env.PUBLIC_URL}/assets/images/raid2026/logo_jtcc_horizontal_white.svg`;

export default function CompanyOverviewFooter() {
  return (
    <footer
      id="company-overview-footer"
      className={styles.footer}
      aria-labelledby="raid-company-overview"
    >
      <div className={styles.panel}>
        <div className={styles.header}>
          <div>
            <p className={styles.eyebrow}>{COMPANY_OVERVIEW.eyebrow}</p>
            <h2 id="raid-company-overview" className={styles.title}>
              {COMPANY_OVERVIEW.title}
            </h2>
          </div>
          <img
            src={LOGO_WHITE_SRC}
            alt="日本トレカセンター"
            className={styles.logo}
            loading="lazy"
            decoding="async"
            width="193"
            height="28"
          />
        </div>

        <dl className={styles.details}>
          {COMPANY_OVERVIEW.details.map(({ label, value }) => (
            <div className={styles.row} key={label}>
              <dt className={styles.label}>{label}</dt>
              <dd className={styles.value}>{value}</dd>
            </div>
          ))}
        </dl>

        <div className={styles.bottom}>
          <a className={styles.topLink} href={COMPANY_OVERVIEW.topLink.href}>
            {COMPANY_OVERVIEW.topLink.label}
          </a>
          <p className={styles.copyright}>{COMPANY_OVERVIEW.copyright}</p>
        </div>
      </div>

      <div className={styles.xArea}>
        <p className={styles.xEyebrow}>OFFICIAL X</p>
        <a
          className={styles.xButton}
          href={COMPANY_OVERVIEW.xLink.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`X 公式アカウント ${COMPANY_OVERVIEW.xLink.handle}（新規タブで開く）`}
        >
          <svg
            className={styles.xIcon}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
          </svg>
          <span className={styles.xHandle}>
            {COMPANY_OVERVIEW.xLink.handle}
          </span>
        </a>
      </div>
    </footer>
  );
}
